module.exports = __webpack_public_path__ + "static/pub-circle-18794b92a0f4aff66a376b5733086aed.png";